import React, { useState } from 'react';
import { SmartDataTable } from '@src/components/SmartDataTable';
import {
  useInsideStockPurchasesColumns,
  useInsideStockPurchasesFormFields,
} from './hooks';
import { PaymentFormModal } from '@src/pages/payments/components';
import { useInvalidate } from '@refinedev/core';

export const InsideStockPurchasesPage = () => {
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [paymentInitialValues, setPaymentInitialValues] = useState<any>({});
  const invalidate = useInvalidate();

  const handlePaymentClick = (transactionData: {
    transaction_type: 'inside-purchase';
    id: number;
    amount: number;
    type: string;
  }) => {
    setPaymentInitialValues({
      type: transactionData.type || 'CLINIC_EXPENSES',
      reference_id: transactionData.id,
      transaction_type: 'DEBIT',
      amount: transactionData.amount,
    });
    setPaymentModalVisible(true);
  };

  const columns = useInsideStockPurchasesColumns({
    onCreateTransaction: handlePaymentClick,
  });
  const formFields = useInsideStockPurchasesFormFields();

  // Dynamic edit form configuration
  const dynamicEditForm = {
    getForm: (record: any) => {
      return {
        fields: formFields(record),
        title: 'Edit Purchase',
        submitText: 'Save Changes',
      };
    },
    getResource: (record: any) => {
      return 'inside-inventory-purchases';
    },
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SmartDataTable
        api={{
          resource: 'inside-inventory-purchases',
        }}
        title="Inside Stock Purchases"
        columns={columns}
        search={{
          enabled: true,
          fields: ['invoice_id', 'supplier_name', 'supplier_mobile'],
          placeholder: 'Search by invoice ID, supplier name, or mobile...',
          debounceMs: 500,
        }}
        createForm={{
          fields: formFields() as any,
          title: 'Add New Purchase',
          submitText: 'Create Purchase',
        }}
        dynamicEditForm={dynamicEditForm}
        formDisplayMode="modal"
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        isFilter={false}
        pageSize={10}
        pageOptions={[10, 20, 50, 100]}
        showSizeChanger={true}
        showQuickJumper={false}
        // showExport={true}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 300px)',
          },
        }}
        rowKey="id"
      />

      {/* Payment Modal */}
      <PaymentFormModal
        visible={paymentModalVisible}
        onClose={() => {
          setPaymentModalVisible(false);
          setPaymentInitialValues({});
        }}
        onSuccess={() => {
          invalidate({
            resource: 'inside-inventory-purchases',
            invalidates: ['list'],
          });
          invalidate({
            resource: 'payments',
            invalidates: ['list'],
          });
        }}
        initialValues={paymentInitialValues}
      />
    </div>
  );
};
